import { createFileRoute } from '@tanstack/react-router'
import { GlobalPackDetailPage } from '@/features/packs/global-pack-detail-page'

export const Route = createFileRoute('/_authenticated/packs/$packSlug')({
  component: GlobalPackDetailPage,
})
